import { ref } from 'vue'

export type LogType = 'info' | 'error' | 'success' | 'warning'

export interface LogEntry {
    id: string
    message: string
    type: LogType
    timestamp: Date
    details?: any
}

const logs = ref<LogEntry[]>([])
const isOpen = ref(false)

export const useDebugLogs = () => {
    const addLog = (message: string, type: LogType = 'info', details?: any) => {
        const id = Math.random().toString(36).substring(7)
        logs.value.unshift({
            id,
            message,
            type,
            timestamp: new Date(),
            details
        })

        // Auto-open on error if desired, or just show badge
        if (type === 'error') {
            // isOpen.value = true // Optional: force open on error
        }
    }

    const clearLogs = () => {
        logs.value = []
    }

    const toggle = () => {
        isOpen.value = !isOpen.value
    }

    return {
        logs,
        isOpen,
        addLog,
        clearLogs,
        toggle
    }
}
